<ion-header collapse="fade" translucent="true">
  <ion-toolbar>
    <ion-title>{{ "ORDERS.ORDERS" | translate }}</ion-title>
    <ion-buttons slot="start">
      <!-- <ion-back-button defaultHref="/" text="{{ 'COMMON.BACK' | translate }}" /> -->
      <ion-back-button />
    </ion-buttons>
    <ion-buttons slot="start">
      <ion-menu-button class="text-primary" mode="md" />
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar class="px-2" mode="ios">
    <div class="flex items-center">
      <ion-searchbar
        mode="ios"
        class="max-w-[550px] w-full !p-0 !pe-1"
        placeholder="{{ 'COMMON.SEARCH' | translate }}"
        (ionChange)="handleSearchInput($event)"
        (ionClear)="handleSearchInput()"
        [value]="searchValue()"
      />
      <ion-button
        color="light"
        mode="ios"
        fill="solid"
        style="--border-radius: 10px; --shadow: 0px"
        class="aspect-square !w-[38px] !shadow-none me-1"
        (click)="store.ordersListCustomersPage({ page: 1, totalPerPage: 7 })"
      >
        <ion-icon slot="icon-only" size="small" name="refresh"></ion-icon>
      </ion-button>
      <div class="relative">
        <ion-button
          id="popover-trigger-order-list"
          color="light"
          mode="ios"
          fill="solid"
          style="--border-radius: 10px; --shadow: 0px"
          class="aspect-square !w-[38px] !shadow-none"
        >
          <ion-icon slot="icon-only" size="small" name="filter"></ion-icon>
        </ion-button>
        @if (store.ordersListCustomersInput().status !== undefined) {
          <div class="absolute -end-0.5 top-0.5 size-2 rounded-full bg-red-500"></div>
        }
      </div>
      <ion-popover trigger="popover-trigger-order-list" triggerAction="click" [dismissOnSelect]="true">
        <ng-template>
          <ion-content class="p-6">
            <ion-item lines="none" (click)="store.ordersListCustomersPage({ status: undefined })">
              <ion-label>{{ "COMMON.ALL" | translate }}</ion-label>
              @if (!store.ordersListCustomersInput().status) {
                <ion-icon slot="end" color="success" size="small" name="checkmark"></ion-icon>
              }
            </ion-item>
            @for (status of orderStatusList; track $index) {
              <ion-item
                lines="none"
                (click)="store.ordersListCustomersPage({ status })"
                class="hover:bg-medium/10 cursor-pointer"
              >
                <ion-text
                  [ngClass]="{
                    primary: status === 'pending',
                    warning: status === 'processing',
                    success: status === 'shipped' || status === 'delivered',
                    danger: status === 'canceled',
                  }"
                >
                  {{ "ENUMS.SubOrderStatus." + status | translate }}
                </ion-text>
                @if (store.ordersListCustomersInput().status === status) {
                  <ion-icon slot="end" color="success" size="small" name="checkmark"></ion-icon>
                }
              </ion-item>
            }
          </ion-content>
        </ng-template>
      </ion-popover>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  @switch (store.ordersListCustomersState().type) {
    @case ("loading") {
      <mtjr-loading />
    }
    @case ("error") {
      <mtjr-error [failure]="store.ordersFailure()" />
    }
    @case ("success") {
      <ion-list class="flex justify-center !bg-transparent">
        <div class="h-full w-full max-w-[750px] items-center pb-6">
          @for (order of store.orders(); track $index) {
            <ion-card class="my-2 p-4" [routerLink]="[order.id]">
              <div class="mb-1 flex items-center">
                <div class="flex flex-1 flex-col">
                  <div class="flex items-center justify-between">
                    <ion-text>{{ "ORDERS.ORDER_ID" | translate }}</ion-text>
                    <ion-button fill="clear" size="small" color="warning" (click)="reorder(order, $event)" class="">
                      <ion-icon slot="start" name="cart-outline"></ion-icon>
                      {{ "ORDERS.REORDER" | translate }}
                    </ion-button>
                  </div>
                  <div class="flex mt-1 flex-wrap items-center justify-between">
                    <div class="flex items-center">
                      <ion-text color="dark" class="text-lg flex-1">{{ order.orderNo }}</ion-text>
                    </div>
                    <div class="flex items-center">
                      <ion-label class="font-bold flex items-center">
                        <ion-icon class="me-2 text-lg" [name]="order.paymentMethod"></ion-icon>
                        <ion-text color="dark">
                          {{ "ENUMS.PaymentMethod." + order.paymentMethod | translate }}
                        </ion-text>
                      </ion-label>
                      @if (store.orderInfo()[order.id]; as orderInfo) {
                        <div class="bg-medium/30 h-4 w-[1px] mx-4"></div>
                        <div class="flex items-center">
                          <ion-text color="primary" class="text-lg font-bold ms-auto">
                            {{ orderInfo.orderTotal | vxCurrency }}
                          </ion-text>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>

              <div class="bg-light h-[1px] mt-4 w-full"></div>

              @if (store.orderInfo()[order.id]; as orderInfo) {
                <div class="mt-2 flex items-center">
                  <div class="flex items-center mt-1 w-full">
                    <ion-text color="medium" class="me-2">{{ "COMMON.DATE" | translate }}:</ion-text>
                    <ion-text color="dark">{{ order.createdAt | date: "yyyy-MM-dd" }}</ion-text>
                    <ion-text class="ms-auto">
                      {{ "ORDERS.ITEMS_COUNT" | translate }}
                      <span class="ms-2">( {{ orderInfo.totalItems }})</span>
                    </ion-text>
                  </div>
                </div>
                <div class="mt-4 flex">
                  @for (item of orderInfo.orderProducts.slice(0, 5); track $index) {
                    <mtjr-img
                      [src]="
                        item.productImage ??
                        item.variationImage ??
                        'https://nbg1.your-objectstorage.com/mtjr-prod/product-placeholder.webp'
                      "
                      [imgClass]="
                        'w-12 aspect-square rounded-lg p-[0.2px] border border-solid border-medium/30 me-2 ' +
                        (item.productType === 'digital' ? 'object-contain' : 'object-cover')
                      "
                      alt="{{ 'PRODUCTS.PRODUCT_IMAGE' | translate }}"
                    />
                  }
                  @if (orderInfo.orderProducts.length > 5) {
                    <div class="border-medium/50 flex aspect-square w-12 rounded-lg border border-solid">
                      <ion-text color="primary" class="text-md m-auto">
                        +{{ orderInfo.orderProducts.length - 5 }}
                      </ion-text>
                    </div>
                  }
                </div>
              }
            </ion-card>
          } @empty {
            <div class="flex h-full w-full flex-col items-center justify-center">
              <mtjr-dynamic-img
                src="/assets/no_orders.svg"
                darkSrc="/assets/no_orders_dark.svg"
                class="size-[220px] opacity-80 dark:opacity-70"
              />
              <p class="text-medium/70 mt-2 text-center">{{ "ORDERS.NO_ORDERS" | translate }}</p>
            </div>
          }
        </div>
      </ion-list>
    }
  }
  <ion-infinite-scroll (ionInfinite)="onIonInfinite($event)">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
